import React from 'react'
import { Redirect } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import './quickList.css'
import SearchQuickList from './SearchQuickList'

export default function QuickListSettings() {
  const hasQuickListSettingsPermission = useValidatePermission(
    VAPermissions.settingsQuickList
  )

  if (!hasQuickListSettingsPermission) {
    return <Redirect to={ROUTES.home} />
  }

  return (
    <>
      <Navigation />
      <div
        className="quick-list-container"
        data-testid="container-quick-list-settings">
        <div className="quick-list-header">
          <h1 className="quick-list-title">{t('SETTINGS_T.QUICK_LIST')}</h1>
        </div>
        <SearchQuickList />
      </div>
    </>
  )
}
